'use strict';

var LadderDetailsActionsToolbarController = function LadderDetailsActionsToolbarController($scope) {
  function swapObjects(collection, index1, index2) {
    var temp = collection[index1];
    collection[index1] = collection[index2];
    collection[index2] = temp;
  }
  function getCollection() {
    return $scope.allRows;
  }
  function getSelectedElement() {
    return $scope.currentRow;
  }
  function getIndexOfSelectedElement() {
    return getCollection().indexOf(getSelectedElement());
  }
  function isAnyElementSelected() {
    return getCollection() && getIndexOfSelectedElement() !== -1;
  }
  $scope.moveUpElementAvailable = function () {
    return isAnyElementSelected() && getIndexOfSelectedElement() > 0;
  };
  $scope.moveUpElement = function () {
    if ($scope.moveUpElementAvailable()) {
      var index = getIndexOfSelectedElement();
      swapObjects(getCollection(), index, index - 1);
    } else {
      throw new Error('Not allowed operation');
    }
  };
  $scope.moveDownElementAvailable = function () {
    return isAnyElementSelected() && getIndexOfSelectedElement() < getCollection().length - 1;
  };
  $scope.moveDownElement = function () {
    if ($scope.moveDownElementAvailable()) {
      var index = getIndexOfSelectedElement();
      swapObjects(getCollection(), index, index + 1);
    } else {
      throw new Error('Not allowed operation');
    }
  };
};
LadderDetailsActionsToolbarController.$inject = ['$scope'];
module.exports = LadderDetailsActionsToolbarController;